import { createSlice } from "@reduxjs/toolkit";

const statusConfig = [
  {
    label: "New",
    value: "new",
    icon: "fa-solid fa-flag",
    iconBaseClass: "fas",
    //color: "var(--text-color)",
    color: "#e2e2e2"
  },
  {
    label: "New - Assigned",
    value: "New-Assigned",
    icon: "fa-solid fa-user-xmark",
    iconBaseClass: "fas",
    //color: "#EC6547",
    color: "#EDE15B"
  },
  {
    label: "Ground Inspection",    // 1
    value: "ground-inspection",
    icon: "fa-solid fa-user",
    iconBaseClass: "fas",
    //color: "#F46A9B",
    color: "#EDE15B"
  },
  {
    label: "Re-Inspection",       // 2
    value: "re-inspection",
    icon: "fa-solid fa-share",
    iconBaseClass: "fas",
    //color: "#61E2F4",
    color: "#EDE15B"
  },
  {
    label: "Govt. Campus",             // 3
    value: "govt-campus",
    icon: "fa-solid fa-landmark-flag",
    iconBaseClass: "fas",
    //color: "#D5D5D5",
    color: "#86D87F"
  },
  {
    label: "N.A.",                     // 4
    value: "not-applicable",
    icon: "fa-solid fa-circle-minus",
    iconBaseClass: "fas",
    //color: "#b273ff",
    color: "#86D87F"
  },
  {
    label: "PMAY",                    // 5
    value: "pmay",
    icon: "fa-solid fa-circle-minus",
    iconBaseClass: "fas",
    //color: "var(--text-color)",
    color: "#86D87F",
    type: "image",
    image: "pmay-logo.png",
  },
  {
    label: "Map Issued",              // 6
    value: "map-issued",
    icon: "fa-solid fa-map",
    iconBaseClass: "fas",
    //color: "#27AEEF",
    color: "#86D87F"
  },
  {
    label: "Map Submitted",              // 7
    value: "map-submitted",
    icon: "fa-solid fa-map",
    iconBaseClass: "fas",
    //color: "#27AEEF",
    color: "#86D87F"
  },
  {
    label: "Notice",             // 8
    value: "notice",
    icon: "fa-solid fa-file-circle-exclamation",
    iconBaseClass: "fas",
    color: "#EF9B20",
  },
  {
    label: "D.O Issued",          // 9
    value: "do-issued",
    icon: "fa-solid fa-circle-exclamation",
    iconBaseClass: "fas",
    //color: "#BDCF32",
    color: "#EF9B20"
  },
  {
    label: "Sealed",            // 10
    value: "sealed",
    icon: "fa-solid fa-lock",
    iconBaseClass: "fas",
    //color: "#EDE15B",
    color: "#EC6547"
  },
  {
    label: "Court Case",             // 11
    value: "court-case",
    icon: "fa-solid fa-landmark",
    iconBaseClass: "fas",
    //color: "#B33DC6",
    color: "#EC6547"
  },
  {
    label: "Demolished",           // 12
    value: "demolished",
    icon: "fa-solid fa-hammer",
    iconBaseClass: "fas",
    //color: "#86D87F",
    color: "#EC6547"
  }
  // {
  //   label: "Compounding Map",
  //   value: "compounding-map",
  //   icon: "fa-solid fa-indian-rupee-sign",
  //   iconBaseClass: "fas",
  //   color: "#D9A8FF",
  // },
  
  // {
  //   label: "OBPAS",
  //   value: "obpas",
  //   icon: "fa-solid fa-book-open",
  //   iconBaseClass: "fas",
  //   color: "#FF4185",
  // },
];

const statusConfigMap = {
  "new": {
    label: "New",
    value: "new",
    icon: "fa-solid fa-flag",
    iconBaseClass: "fas",
    //color: "var(--text-color)",
    color: "#e2e2e2"
  },
  "New-Assigned": {
    label: "New - Assigned",
    value: "New-Assigned",
    icon: "fa-solid fa-user-xmark",
    iconBaseClass: "fas",
    //color: "#EC6547",
    color: "#EDE15B"
  },
  "ground-inspection": {
    label: "Ground Inspection",
    value: "ground-inspection",
    icon: "fa-solid fa-user",
    iconBaseClass: "fas",
    //color: "#F46A9B",
    color: "#EDE15B"
  },
  "re-inspection": {
    label: "Re-Inspection",
    value: "re-inspection",
    icon: "fa-solid fa-share",
    iconBaseClass: "fas",
    //color: "#61E2F4",
    color: "#EDE15B"
  },
  "govt-campus": {
    label: "Govt. Campus",
    value: "govt-campus",
    icon: "fa-solid fa-landmark-flag",
    iconBaseClass: "fas",
    //color: "#D5D5D5",
    color: "#86D87F"
  },
  "not-applicable": {
    label: "N.A.",
    value: "not-applicable",
    icon: "fa-solid fa-circle-minus",
    iconBaseClass: "fas",
    //color: "#b273ff",
    color: "#86D87F"
  },
  pmay: {
    label: "PMAY",
    value: "pmay",
    icon: "fa-solid fa-circle-minus",
    iconBaseClass: "fas",
    //color: "var(--text-color)",
    color: "#86D87F",
    type: "image",
    image: "pmay-logo.png",
  },
  "map-issued": {
    label: "Map Issued",
    value: "map-issued",
    icon: "fa-solid fa-map",
    iconBaseClass: "fas",
    //color: "#27AEEF",
    color: "#86D87F"
  },
  "map-submitted": {
    label: "Map Submitted",
    value: "map-submitted",
    icon: "fa-solid fa-map",
    iconBaseClass: "fas",
    //color: "#27AEEF",
    color: "#86D87F"
  },
  notice: {
    label: "Notice",
    value: "notice",
    icon: "fa-solid fa-file-circle-exclamation",
    iconBaseClass: "fas",
    color: "#EF9B20",
  },
  "do-issued": {
    label: "D.O Issued",
    value: "do-issued",
    icon: "fa-solid fa-circle-exclamation",
    iconBaseClass: "fas",
    //color: "#BDCF32",
    color: "#EF9B20"
  },
  sealed: {
    label: "Sealed",
    value: "sealed",
    icon: "fa-solid fa-lock",
    iconBaseClass: "fas",
    //color: "#EDE15B",
    color: "#EC6547",
  },
  "court-case": {
    label: "Court Case",
    value: "court-case",
    icon: "fa-solid fa-landmark",
    iconBaseClass: "fas",
    //color: "#B33DC6",
    color: "#EC6547",
  },
  demolished: {
    label: "Demolished",
    value: "demolished",
    icon: "fa-solid fa-hammer",
    iconBaseClass: "fas",
    //color: "#86D87F",
    color: "#EC6547"
  },
  // "compounding-map": {
  //   label: "Compounding Map",
  //   value: "compounding-map",
  //   icon: "fa-solid fa-indian-rupee-sign",
  //   iconBaseClass: "fas",
  //   color: "#D9A8FF",
  // },
  // obpas: {
  //   label: "OBPAS",
  //   value: "obpas",
  //   icon: "fa-solid fa-book-open",
  //   iconBaseClass: "fas",
  //   color: "#FF4185",
  // },
};

const initialState = {
  data: statusConfig,
  dataMap: statusConfigMap,
  statusDropdownVisibility: false,
  selected: {
    "new": true,
    "New-Assigned": true,
    "ground-inspection": true,
    "re-inspection": true,
    "govt-campus": true,
    "not-applicable": true,
    pmay: true,
    "map-issued": true,
    "map-submitted": true,
    notice: true,
    "do-issued": true,
    sealed: true,
    "court-case": true,
    demolished: true,
    // "compounding-map": true,
    // obpas: true,
  },
  loading: false,
  error: null,
};

const siteStatus = createSlice({
  name: "siteStatus",
  initialState,
  reducers: {
    fetchSiteStatusStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSiteStatusSuccess(state, action) {
      console.log("fetchDataSuccess sitestatus success");
      state.loading = false;
      state.data = action.payload;
      console.log("fetchDataSuccess sitestatus success data");
    },
    selectSiteStatus(state, action) {

      state.loading = false;
      state.selected = {
        ...state.selected,
        ...action.payload,
      };
    },
    setStatusDropdownVisibility(state, action) {
      state.statusDropdownVisibility = action.payload;
    },
    fetchSiteStatusFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSiteStatusStart,
  fetchSiteStatusSuccess,
  selectSiteStatus,
  fetchSiteStatusFailure,
  setStatusDropdownVisibility,
} = siteStatus.actions;
export default siteStatus.reducer;
